import { useConfigurationIntValue } from "./useConfigurationIntValue";

// Returns a number representing the desired polling interval in milliseconds
export function useDedupeInterval(): number {
  return useConfigurationIntValue("DEDUPE_INTERVAL", 4000);
}
